import React from "react";
import "./PreviewTip.css";
import { t } from "../i18n";

// The second line of the "Preview — fans see this…" banner while the page
// has neither a venue nor a bio (founder, build 44, pick B: one banner, "always
// if both are blank, not just on welcome"). A tap opens Edit profile.
export default function PreviewTip({ onTap }: { onTap: () => void }) {
  return (
    <button type="button" className="preview-tip-link" onClick={onTap}>
      {t("profilePage.addVenueOrBio")} <span aria-hidden="true">›</span>
    </button>
  );
}
